import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const SandboxEnterpriseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SandboxEnterprise"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idBoard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idBoard"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enterprise"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"SandboxEnterprise","document":SandboxEnterpriseDocument}} as const;
export type SandboxEnterpriseQueryVariables = Types.Exact<{
  idBoard: Types.Scalars['ID']['input'];
}>;


export type SandboxEnterpriseQuery = (
  { __typename: 'Query' }
  & { board?: Types.Maybe<(
    { __typename: 'Board' }
    & Pick<Types.Board, 'id'>
    & { enterprise?: Types.Maybe<(
      { __typename: 'Enterprise' }
      & Pick<Types.Enterprise, 'id'>
    )> }
  )> }
);

/**
 * __useSandboxEnterpriseQuery__
 *
 * To run a query within a React component, call `useSandboxEnterpriseQuery` and pass it any options that fit your needs.
 * When your component renders, `useSandboxEnterpriseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSandboxEnterpriseQuery({
 *   variables: {
 *      idBoard: // value for 'idBoard'
 *   },
 * });
 */
export function useSandboxEnterpriseQuery(
  baseOptions: TrelloQueryHookOptions<
    SandboxEnterpriseQuery,
    SandboxEnterpriseQueryVariables
  > &
    (
      | { variables: SandboxEnterpriseQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: SandboxEnterpriseDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    SandboxEnterpriseQuery,
    SandboxEnterpriseQueryVariables
  >(SandboxEnterpriseDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useSandboxEnterpriseLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    SandboxEnterpriseQuery,
    SandboxEnterpriseQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SandboxEnterpriseQuery,
    SandboxEnterpriseQueryVariables
  >(SandboxEnterpriseDocument, options);
}
export function useSandboxEnterpriseSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        SandboxEnterpriseQuery,
        SandboxEnterpriseQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SandboxEnterpriseQuery,
    SandboxEnterpriseQueryVariables
  >(SandboxEnterpriseDocument, options);
}
export type SandboxEnterpriseQueryHookResult = ReturnType<
  typeof useSandboxEnterpriseQuery
>;
export type SandboxEnterpriseLazyQueryHookResult = ReturnType<
  typeof useSandboxEnterpriseLazyQuery
>;
export type SandboxEnterpriseSuspenseQueryHookResult = ReturnType<
  typeof useSandboxEnterpriseSuspenseQuery
>;
export type SandboxEnterpriseQueryResult = Apollo.QueryResult<
  SandboxEnterpriseQuery,
  SandboxEnterpriseQueryVariables
>;
